import classes from "./ChartCardTitle.module.css";
export default function ChartCardTitle({ children, title }) {
  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <h4>{title} </h4>
      </div>
      <div className={classes.pieContainer}>{children}</div>
    </div>
  );
}
